import React, { useMemo, useState } from 'react'
import Select from 'react-select';

const CommonFilter = (props) => {

    const {
        columns = [],
        filterList = [],
        searchDisabled = false,
        getdata,
        setlistdata,
        searchvalue,
        setSearchValue,
        searchby,
        setSerachBy,
        isSerachOptionDropdown = true
    } = props;

    const [clrshow, setsclshow] = useState(false);


    //#region handle search value
    const serachoption = useMemo(() =>
        [...columns, { name: 'All', key: 'All' }]?.filter((fil) => fil?.key && !fil?.omit)?.map((obj) => {
            return { label: obj?.name || obj?.Name, value: obj?.key || obj?.Key }
        }), [columns])

    const handleSearchBy = (e) => {
        setSerachBy(e.value);
    }

    const handleChangeSearchValue = (e) => {
        setSearchValue(e.target.value)
        setsclshow(true)
        if (e.target.value === '') {
            getdata();
            setsclshow(false)
        }
    }

    const onKeyDownHandler = (e) => {
        if (e.keyCode === 13) {
            handleSearch();
        }
    };

    const matchesSearchValueAll = (issec, fields) => {
        let search = searchvalue
        return fields.some((data) =>
            issec[data]?.toString()?.toLowerCase()?.includes(search?.toLowerCase())
        );
    };

    const handleSearch = () => {
        if (searchvalue?.trim()?.length !== 0) {
            const filteritem = filterList;
            let filterdata;
            if (searchby === 'All') {
                filterdata = filteritem?.filter((issec) => {
                    let keys = serachoption?.filter((fil) => fil.value !== 'All')?.map((obj) => obj.value)
                    return matchesSearchValueAll(issec, keys) && issec
                });
            }
            else {
                filterdata = filteritem?.filter((item) =>
                    item?.[searchby]?.toString()?.toLowerCase()?.includes(searchvalue?.toLowerCase())
                );
            }
            setlistdata(filterdata)
        }
    }

    const clearsearch = () => {
        setSearchValue("");
        setsclshow(false);
        getdata();
    }
    //#endregion



    return (
        <div className="row justify-content-end mx-2 mt-3">
            {
                isSerachOptionDropdown &&
                <div className="py-2 px-1 col-lg-2 col-md-4 col-sm-12">
                    <Select
                        className="dropdown select_dropdown"
                        options={serachoption}
                        value={serachoption?.filter(function (serachoption) {
                            return serachoption.value === searchby;
                        })}
                        onChange={handleSearchBy}
                        isDisabled={searchDisabled ? true : false}
                        isSearchable={false}

                    />
                </div>
            }
            <div className="py-2 px-1 col-lg-2 col-md-4 col-sm-12">
                <div className='clrbutton'>
                    <input
                        type="text"
                        onKeyDown={onKeyDownHandler}
                        id="btnSearchText"
                        className="form-control"
                        placeholder='Enter keyword'
                        name="SearchValue"
                        onChange={handleChangeSearchValue}
                        value={searchvalue || ''}
                        disabled={searchDisabled ? true : false}
                        autoComplete='off'
                    />
                    <button className={`${clrshow === true ? "d-block" : "d-none"}`} disabled={searchDisabled ? true : false} onClick={clearsearch} type="reset">&times;</button>
                </div>
            </div>
            <div className="py-2 px-1 text-center col-auto">
                <button type="button" className="btn btn-primary" id="btnSearch" disabled={searchDisabled ? true : false} onClick={handleSearch}>Search</button>
            </div>
        </div>
    )
}

export default CommonFilter
